import { dynamicImage } from "../../../Service/DynamicImage";

//Custom Scrollbar
export const CUSTOM_SCROLL = [
  {
    text: "Used ",
    code: ".vertical-scroll ",
  },
  {
    text: "through design scrollbar.",
  },
];

//Small Size Scrollbars
export const SMALL_SIZE_SCROLL = [
  {
    text: "Use the ",
    code: ".scrollbar-margins ",
  },
  {
    text: "through small scroll and image is draggable. ",
  },
];

//Badges Scrollbars
export const BADGE_SCROLL = [
  {
    text: "Use the ",
    code: ".badge ",
  },
  {
    text: " class through create more badges and ",
    code: ".vertical-scroll ",
  },
  {
    text: "used as vertical scroll.",
  },
];

export const BADGE_SCROLL_LIST = [
  {
    title: "Lola Stanford",
    color: "danger",
    text: "Issue",
  },
  {
    title: "Caitlin Coungeau",
    color: "primary",
    text: "Social",
  },
  {
    title: "Graciela W. McClaran",
    color: "danger",
    text: "Issue",
  },
  {
    title: "Derek T. Aldridge",
    color: "warning",
    text: "Freelance",
  },
  {
    title: "Annie A. Riley",
    color: "primary",
    text: "Social",
  },
  {
    title: "Hana J. Boyd",
    color: "danger",
    text: "Issue",
  },
  {
    title: "Karen R. Pryce",
    color: "warning",
    text: "Freelance",
  },
  {
    title: "Cordie C. Pope",
    color: "primary",
    text: "Social",
  },
];

//Profile Scrollables
export const PROFILE_SCROLL = [
  {
    text: "Use the ",
    code: ".list-group-item ",
  },
  {
    text: "through made profile and with used ",
    code: ".vertical-scroll. ",
  },
];

export const PROFILE_SCROLL_LIST = [
  {
    text: "Sharon C. Obrien",
    src: dynamicImage("user/2.jpg"),
  },
  {
    text: "Bryan A. Owens",
    src: dynamicImage("user/5.jpg"),
  },
  {
    text: "Ronald M. Enger",
    src: dynamicImage("user/12.png"),
  },
  {
    text: "Herbert A. Clary",
    src: dynamicImage("user/14.png"),
  },
  {
    text: "Dino A. Cannon",
    src: dynamicImage("user/6.jpg"),
  },
  {
    text: "Danny A. McLean",
    src: dynamicImage("user/3.jpg"),
  },
  {
    text: "Betty K. Curtis",
    src: dynamicImage("user/2.jpg"),
  },
];

//Scrollable Contents
export const SCROLLABLE_CONTENT = [
  {
    text: "Use the ",
    code: ".list-group-item ",
  },
  {
    text: "through made profile and with used ",
    code: ".vertical-scroll. ",
  },
];

export const SCROLLABLE_CONTENT_LIST = [
  {
    src: dynamicImage("user/10.jpg"),
    text: "Gabrielle Fahey",
    mail: "GabrielleFahey@dayrep.com",
    days: "10 days ago",
  },
  {
    src: dynamicImage("user/2.jpg"),
    text: "Lucinda Moseley",
    mail: "LucindaMoseley@teleworm.us",
    days: "3 days ago",
  },
  {
    src: dynamicImage("user/12.png"),
    text: "Francis K. Henriques",
    mail: "FrancisKHenriques@teleworm.us",
    days: "2 days ago",
  },
  {
    src: dynamicImage("user/14.png"),
    text: "Jose A. Seay",
    mail: "JoseASeay@rhyta.com",
    days: "15 days ago",
  },
  {
    src: dynamicImage("user/3.jpg"),
    text: "Phil F. Cunningham",
    mail: "PhilFCunningham@dayrep.com",
    days: "6 days ago",
  },
  {
    src: dynamicImage("user/7.jpg"),
    text: "Richard E. Johnson",
    mail: "RichardEJohnson@teleworm.us",
    days: "120 days ago",
  },
  {
    src: dynamicImage("user/2.png"),
    text: "Lawrence L. Nash",
    mail: "LawrenceLNash@jourrapide.com",
    days: "8 days ago",
  },
];

//Horizontal Scrollbars
export const HORIZONTAL_SCROLL = [
  {
    text: "Use the ",
    code: ".horizontal-scroll ",
  },
  {
    text: "through move content horizontally.",
  },
];

export const HORIZONTAL_SCROLL_LIST = [dynamicImage("scrollbar/fashion2.jpg"), dynamicImage("scrollbar/fashion3.jpg"), dynamicImage("scrollbar/fashion4.jpg"), dynamicImage("scrollbar/fashion5.jpg"), dynamicImage("scrollbar/fashion6.jpg")];

//Both Side Visible Scrollbars
export const BOTH_SIDE_SCROLL = [
  {
    text: "Use the ",
    code: "visible-scroll ",
  },
  {
    text: "through visible both side scrollbar.",
  },
];